<template>
    <b-btn v-if="isAvailable" :to="{ name: 'ExternalPurchaseCreate', params: { mode: 'create', id: purchase.id } }" class="btn-card-action btn-card-action-light my-1">
        Закупить вне ИС
        <span v-if="purchase.flags.allow_external_purchase_expiration_date" class="text-nowrap">до {{ getDateTimeFormat(purchase.flags.allow_external_purchase_expiration_date) }}</span>
    </b-btn>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-create-external-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.external_purchase;
        }
    }
};
</script>
